import { reactive, ref, watch, computed, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as common from '@/util/common'
import * as apiAlert from '@/api/alert'
import { searchByKeyword, getSearchText, getIsFuzzy, getGASearchClass } from '@/util/search'
import { getSearchTextInputOfSearchUIParam, getIsFuzzyInputOfSearchUIParam } from '@/util/search-ui'
import { getCommonSuggest } from '@/logic/common/CommonSuggest'
import { isInvoicingInformationAvailable } from '@/logic/common/CommonPaymentMethod'

export const getGroup = (props, context) => {
 
  /**
   * メニューの初期表示設定
   */
  const initMenu = () => {
    // 初期の検索フォームの設定(SP画面で使用)
    search.keyword_input = getSearchTextInputOfSearchUIParam(search.searchCategory)
    search.is_fuzzy_input = getIsFuzzyInputOfSearchUIParam(search.searchCategory)
  }

  // メニューが表示されたときに初期表示設定を行う(SP用)
  watch(() => props.parentVisibleMenu, (now, prev) => {
    if (store.state.common.device === 'sp') {
      if (now) {
        // メニューの初期表示設定
        initMenu()
      }
    }
  })

  onBeforeMount(() => {

    if (store.state.common.device === 'pc') {
      // メニューの初期表示設定
      initMenu()
    }
  
    // store
    //   .dispatch('profile/fetch')
    //   .then(() => {
    //     store.dispatch('profile/getUserImage')
    //   })
    const params = {
      is_unread_only: 1
    }
    apiAlert
      .count(params)
      .then(response => {
        const { data } = response
        if (data.status === 0) {
          // alert.count = data.count
          store.dispatch('alert/setUnreadCount', data.count)
        } else {
          common.commonErrorMessage(response)
        }
      })
  })

  const state = reactive({
    visibleProfile: false,
    visibleSearchDetail: false, // 詳細検索ウィンドウ表示フラグ
    isOpenSearchCategory: false,
    visibleSearchBooksList: false, // SP用
    visibleSearchPackageList: false, // SP用
    visibleSearchCourtList: false, // SP用
    visibleSearchPastYearBookList: false, // SP用
    // 資料検索ボタンの表示条件
    isDocumentLinkShown: computed(() => {
      return store.state.profile.book_revision_id.length > 0
    })
  })

  const alert = reactive({
    count_disp: computed(() => {
      if (store.state.alert.unreadCount >= 10) {
        return '9+'
      } else {
        return String(store.state.alert.unreadCount)
      }
    })
  })

  const profile = reactive(store.state.profile)
  const isAdmin = computed(() => store.getters['profile/isAdmin'])
  const isWLJOP = computed(() => store.getters['profile/isWLJOP'])

  const menu = reactive({
    // 呼び出し元の名前
    parentName: computed(() => {
      return props.parentName
    }),
    general: computed(() => {
      if (store.state.common.device === 'sp') {
        return []
      } else {
        return [
          { name: 'PCDashboard', display: 'ダッシュボード', is_available_from_admin_system: true },
          { name: 'PCBookList', display: '書籍', is_available_from_admin_system: true },
          { name: 'PCKnowledgeList', display: '最新ナレッジ', is_available_from_admin_system: false },
          { name: 'PCNoteList', display: 'ノート', is_available_from_admin_system: false },
          { name: 'PCDocumentDownloadsList', display: '書式ダウンロード', is_available_from_admin_system: true },
          { name: 'PCViewLaterList', display: '後で見る', is_available_from_admin_system: false },
          { name: 'PCBookmarkList', display: 'ブックマーク', is_available_from_admin_system: false },
          { name: 'PCHistoryOfView', display: '閲覧履歴', is_available_from_admin_system: false },
          { name: 'PCDocumentSearch', display: '資料検索', is_available_from_admin_system: false }
        ]
      }
    }),
    /**
     * メニューボタン表示判定
     * @param {*} list 
     * @returns 
     */
    isMenuButtonShown: (list) => {
      let isShown = true
      if (common.isFromAdminSystem() && !list.is_available_from_admin_system) {
        // 管理システムから遷移してきた場合で、is_available_from_admin_system=falseの場合は表示しない
        isShown = false
      }
      if (list.name === 'PCDocumentSearch' && !state.isDocumentLinkShown) {
        // 資料検索ボタンの場合で、資料検索表示フラグがfalse（書籍リビジョンIDが存在しない）場合は表示しない
        isShown = false
      }
      return isShown
    },
    admin: computed(() => {
      if (store.state.common.device === 'sp') {
        return []
      } else {
        const adminMenus = []
        adminMenus.push({ name: 'PCContract', display: '契約情報', admin: true})
        adminMenus.push({ name: 'PCService', display: 'サービス管理', admin: true})
        adminMenus.push({ name: 'PCContractAccount', display: '利用者アカウント管理', admin: true, wljop: true})
        adminMenus.push({ name: 'PCContractAssignLicense', display: 'ライセンス管理', admin: true, wljop: true})
        adminMenus.push({ name: 'PCContractHistoryOfPurchase', display: '申し込み履歴', admin: true})
        if (isInvoicingInformationAvailable()) {
          adminMenus.push({ name: 'PCContractInvoicingInformation', display: 'ご請求案内', admin: true})
        }
        adminMenus.push({ name: 'PCInquiryInput', display: 'お問い合わせ'})
        return adminMenus
      }
    }),
    // 管理者のみ表示可能なメニューの制御
    adminMenuList: computed(() => menu.admin.filter((item) => {
      return !item.admin ||
        (isAdmin.value && !isWLJOP.value) ||
        (isAdmin.value && isWLJOP.value && item.wljop)
    })),
    routerTo: (name) => {
      
      if (router.currentRoute.name === name) {
        // 同一ページの場合
        closeMenu()
      } else {
        // 同一ページ以外から遷移する場合

        if (name === 'PCBookList' || name === 'SPBookList' || name === 'PCDocumentDownloadsList') {
          // 書籍一覧画面または、書式ダウンロード画面に遷移する場合
  
          // 書籍ID、QA IDを初期化(書籍、書式DLに遷移する場合、リセットしてから遷移)
          store.dispatch('qa/setBookId', 0)
          store.dispatch('qa/setBookName', '')
          store.dispatch('qa/setQaId', 0)
          store.dispatch('qa/setSearchIndexId', 0)
          store.dispatch('qa/setNumberCarouselVisible', 0)
        }
  
        if (name === 'PCBookList' || name === 'SPBookList') {
          // 書籍一覧画面に遷移する場合
  
          // 書籍一覧画面遷移用の初期化
          store.dispatch('bookList/setMainListType', 'book')
          store.dispatch('bookList/setBookId', 0)
          store.dispatch('bookList/setBookName', '')
  
          // 書籍一覧に遷移する場合は、書籍一覧の検索条件をクリアしてから遷移
          store.dispatch('search/setBookSearchParam', {})
        } else if (name === 'PCDocumentDownloadsList') {
          // 書式ダウンロード画面に遷移する場合
          // 書式ダウンロードに遷移する場合は、書式ダウンロードの検索条件をクリアしてから遷移
          store.dispatch('search/setDownloadSearchParam', {})
        }
  
        // 遷移
        router.push({ name: name })
      }
    }
  })

  const background = reactive({
    image: computed(() => {
      const template = store.state.profile.template
      return common.getTemplateImage(template)
    })
  })

  const search = reactive({
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    }),
    searchCategoryLists: {
      qa: 'Q&A・事例',
      knowledge: '最新ナレッジ',
      book: '書籍目次',
      download: '書式ダウンロード',
      note: 'ノート'
    },
    // セレクトボックス変更時に値を取り直すように
    changeCategory: () => {
      if (store.state.common.device === 'sp') {
        // 検索カテゴリのプルダウンを閉じる
        state.isOpenSearchCategory = false
      }

      search.keyword_input = search.keyword
      search.is_fuzzy_input = search.is_fuzzy
    },
    searchCategoryName: computed(() => search.searchCategoryLists[search.searchCategory]),
    // 検索ボタン＆検索フォームのGA用class
    gaSearchClass: computed(() => {
      return getGASearchClass('menu', search.searchCategory)
    }),
    // キーワード入力欄に入力した文字列
    keyword: computed(() => {
      return getSearchText(search.searchCategory)
    }),
    keyword_input: '', // データバインディング用
    // 表記の揺れを含む：0(曖昧検索),1(一致検索)
    is_fuzzy: computed(() => {
      return getIsFuzzy(search.searchCategory)
    }),
    is_fuzzy_input: 0, // データバインディング用

    qaSearchDetail: {},
    clickSearch: async() => {

      const searchCategory = search.searchCategory
      const searchText = search.keyword_input
      const isFuzzy = search.is_fuzzy_input

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      // 同画面で検索の場合用の設定
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: searchText, isFuzzy: isFuzzy })
      // 別画面に遷移して検索する場合用の設定
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: searchCategory, searchText: searchText, isFuzzy: isFuzzy })

      if (store.state.common.device === 'sp') {
        if (searchCategory === 'book') {
          // 書籍一覧画面遷移用の初期化
          // 表示中の目次のノードIDをリセット → 書籍目次画面のトップが表示される
          store.dispatch('bookList/setTargetNodeIdOfTableOfContents', 0)

          // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
          store.dispatch('bookList/setMainListType', 'book')
        }
      }

      // 詳細検索フラグをリセットする
      store.dispatch('qa/setSearchDetail', false)

      // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
      searchByKeyword(context, searchCategory, searchText, isFuzzy) 
    },
    searchDetail: (isResetSearchCondition) => {

      if (router.currentRoute.name === 'PCQAList' || router.currentRoute.name === 'SPQAList') {
        // QA一覧画面の場合

        if (isResetSearchCondition) {
          // 「検索条件をリセット」を実行した場合
          // メニューは閉じない

        } else {
          // 詳細検索の場合
          // メニューを閉じる
          closeMenu()
        }

        // 検索を実行
        context.parent.group1.searchWithOptions({from_menu: true})

      } else {
        // QA一覧画面でない場合
        // QA一覧画面に遷移
        if (store.state.common.device === 'sp') {
          router.push({ name: 'SPQAList' }).catch(() => {})
        } else {
          router.push({ name: 'PCQAList' }).catch(() => {})
        }
      }
    },
    clearSearchInput: () => {
      search.keyword_input = ''
      search.is_fuzzy_input = 0

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: search.searchCategory, searchText: '', isFuzzy: 0 })
    }

  })

  const suggest = getCommonSuggest(search)

  const closeMenu = () => {
    context.emit('closeMenu')
  }

  return {
    suggest,
    state,
    alert,
    profile,
    menu,
    background,
    search,
    closeMenu
  }

}
